// removed by extract-text-webpack-plugin
module.exports = {"bp":"(min-width: 700px)","gray":"#EFEFEF","black":"#000000","wrapper":"src-pages----SolutionsPage-module---wrapper---1rGqI"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/SolutionsPage.module.css
// module id = 639
// module chunks = 129448336650289